
export const billingRounding = (n: number): number =>
    Math.ceil(Math.floor(n * 2) / 2);